module.exports = __webpack_public_path__ + "img/accordion_01.e151bbed.jpg";